import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HAZARD_LABEL } from "@/lib/hazard";

const REASON = {
  news_first: "News first — an earlier same-hazard GDELT article existed",
  agency_first: "Agency first — the agency report came before Vigilo Earth's flag",
  no_flag_time: "Missing flag or report time",
  duplicate_event: "Same agency event already broadcast for a neighbouring call",
};

// Confirmed calls that did NOT get a public broadcast, with the first-spotted reason (for reviewers).
export const SkippedCalls = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.confirmedSkipped().then(setRows).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <section className="border border-white/10 bg-atlas-surface/70 p-4 mb-8" data-testid="skipped-calls">
      <div className="text-[10px] font-mono uppercase tracking-widest text-atlas-secondary mb-2">Confirmed but not broadcast (first-spotted rule)</div>
      {rows.map((r) => (
        <div key={r.uid} className="flex justify-between gap-3 py-1 border-b border-white/5 text-[11px] font-mono" data-testid={`skipped-${r.uid}`}>
          <span className="text-white truncate">{HAZARD_LABEL[r.hazard] || r.hazard} · {r.region}</span>
          <span className="text-amber-300 shrink-0">{REASON[r.ba_skip_reason] || r.ba_skip_reason}</span>
        </div>
      ))}
    </section>
  );
};
